var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"test"}},[_c('div',{staticClass:"loginContainer"},[_c('a',{staticClass:"openApp",attrs:{"href":_vm.app.packageName}},[_vm._v("開APP")]),_c('br'),_c('label',[_vm._v(_vm._s(_vm.count))])]),_c('div',{staticClass:"loginBackground"})])
}
var staticRenderFns = []

export { render, staticRenderFns }